import * as React from "react";
import styles from './Contact.module.css';
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import * as constants from "../../../constants";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

type ContactInfoProps = {
  view: string;
};

const formatPhone = (number: any) => {
  const cleaned = number.replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  return match ? `(${match[1]}) ${match[2]}-${match[3]}` : number;
};

const ContactInfo: React.FC<ContactInfoProps> = ({ view }) => {
  const contactInformation = useSelector((state: RootState) => state.participantAdminProfile);
  const userDetails = useSelector((state: RootState) => state.auth);
  const info = userDetails?.clientVo;
  const { t } = useTranslation();
  //  <MenuItem onClick={() => handleMenuItemClick("/qboLandingPage")}>
  //                     {translate('setUpqbo')}
  //                   </MenuItem>
  // Handles Navigation on Menu Click
  const navigate = useNavigate();

  const handleMenuItemClick = (route: string) => {
    navigate('/qboLandingPage');
  };
  const translate = t as (key: string) => string;
  const outerWrapperStyle = view === 'Left'
    ? { paddingLeft: 0, paddingRight: 20 }
    : { paddingLeft: '6.5%', paddingRight: '6.5%' };
  const paddingStyle = userDetails.roles?.roleName != constants.ROLES_PROJECT_MANAGER ? { paddingTop: 5 } : { paddingTop: 0 }
  return (
    <>
      {userDetails && userDetails.clientVo ? (
        <div className={styles.container} style={paddingStyle}>
          <div className={styles.outerWrapper} style={outerWrapperStyle}>
            <div className={styles.innerWrapper} >
              <div className={styles.contactInfo}>
                <span className={styles.regularText}>
                  {translate('forAssistancePleaseEmail')}&nbsp;
                </span> 
                {info?.helpdeskMail && (
                  <a
                    href={`mailto:${info.helpdeskMail}`}
                    className={styles.importantText}
                    title={`Email to ${info.helpdeskMail}`}
                  >
                    {info.helpdeskMail}
                  </a>
                )} 
                <span className={styles.regularText}>
                  {" "}
                  {translate('orCall')}{" "}
                  <span>
                    {info?.helpdeskNumber ? formatPhone(info.helpdeskNumber) : ""}
                  </span>
                </span>
              </div>

              {userDetails.roles?.roleName != constants.ROLES_PROJECT_MANAGER && <div className={styles.adminView}>{contactInformation?.participantAdminProfile}</div>}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default ContactInfo;